import {TimelineMax, CSSPlugin, AttrPlugin, TweenMax} from 'gsap/all'
// import 'gsap'
import {Howl, Howler} from 'howler'

window.$ = require('jquery')
window._ = require('underscore')

// Make sure babel doesn't trim the plugins from the DOM tree
const plugins = [ CSSPlugin, AttrPlugin ]
Howler.volume(1)

const zoomWindows = [
  '#ZoomRect',
  '#ZoomCloseButton',
  '#BrokenBonesZoom',
  '#BackgroundMask',
  '#InternalFixationZoom',
  '#HumanStressReaction',
  '#DeadBone',
  '#NecroticBoneResorbed',
  '#BMGFixationZoom',
  '#BMGHardwareZoom',
  '#IntimateAlignmentZoom',
  '#DirectHaversianZoom',
  '#ConventionalFixationZoom',
  '#CompressionLostZoom',
  '#HumanComplicationsZoom',
  '#HorseComplicationsZoom',
  '#SecondaryHealingZoom',
  '#SecondaryHaversianRemodelingZoom'
]

var button1Blink = null
var button2Blink = null
var button3Blink = null
var button4Blink = null
var hideStuff = null
var animeSequence = null
var animeZoom = null
var curAudio = null
var _01Audio = new Howl({
  src: [require('../audio/1WelcomeDeadBoneGapsQuantified.mp3')],
  loop: false,
  autoplay: false,
  volume: 1,
  preload: true,
  autoSuspend: false,
  html5PoolSize: 1,
  onunlock: function (event) {
    console.log(this._src + ' is Unlocked! Duration is', this.duration())
  },
  onend: function () {
    animeSequence.seek('end').play()
    curAudio = null
  }
})
var _02Audio = new Howl({
  src: [require('../audio/2InstabilityGapWideningGranulationTissue.mp3')],
  loop: false,
  autoplay: false,
  volume: 1,
  preload: true,
  autoSuspend: false,
  html5PoolSize: 1,
  onunlock: function (event) {
    console.log(this._src + ' is Unlocked! Duration is', this.duration())
  },
  onend: function () {
    animeSequence.seek('end').play()
    curAudio = null
  }
})
var _03Audio = new Howl({
  src: [require('../audio/3SecondaryHealing.mp3')],
  loop: false,
  autoplay: false,
  volume: 1,
  preload: true,
  autoSuspend: false,
  html5PoolSize: 1,
  onunlock: function (event) {
    console.log(this._src + ' is Unlocked! Duration is', this.duration())
  },
  onend: function () {
    animeSequence.seek('end').play()
    curAudio = null
  }
})
var _04Audio = new Howl({
  src: [require('../audio/4PrimaryHealingInvitationToExplore.mp3')],
  loop: false,
  autoplay: false,
  volume: 1,
  preload: true,
  autoSuspend: false,
  html5PoolSize: 1,
  onunlock: function (event) {
    console.log(this._src + ' is Unlocked! Duration is', this.duration())
  },
  onend: function () {
    animeSequence.seek('end').play()
    curAudio = null
  }
})

var audio = [
  _01Audio,
  _02Audio,
  _03Audio,
  _04Audio
]

const zooms = [
  '#ZoomRect',
  '#ExtraZoomRect',
  '#_2ndExtraZoomRect',
  '#_3rdExtraZoomRect',
  '#MoreArrow',
  '#_2ndMoreArrow',
  '#_3rdMoreArrow',
  '#ZoomCloseButton',
  '#ZoomCloseButton2',
  '#ZoomCloseButton3',
  '#ZoomCloseButton4',
  '#BrokenBonesZoom',
  '#InternalFixationZoom',
  '#DeadBone',
  '#HighlyRestrictedZoom',
  '#CompressionLostZoom',
  '#SecondaryHealingZoom',
  '#BMGHardwareZoom',
  '#SecondaryHaversianRemodelingZoom',
  '#IntimateAlignmentZoom',
  '#DirectHaversianZoom',
  '#SecondaryFinalBone',
  '#PrimaryFinalBone'
]

export default {
  doStartAnime: function () {
    hideStuff = new TimelineMax()
    hideStuff.to('#Pause-ResumeButton, #StopButton, #_01Explanation, #_02Explanation', 0, {opacity: 0})
      .to(zooms, 0, {opacity: 0})
    button1Blink = new TimelineMax({
      yoyo: true,
      repeat: -1,
      repeatDelay: 0.25
    })
    button1Blink.to('#ControlButton1', 0.25, {opacity: 0.75})
    button2Blink = new TimelineMax({
      yoyo: true,
      repeat: -1,
      repeatDelay: 0.25
    })
    button2Blink.to('#ControlButton2', 0.25, {opacity: 0.75})
    button3Blink = new TimelineMax({
      yoyo: true,
      repeat: -1,
      repeatDelay: 0.25
    })
    button3Blink.to('#ControlButton3', 0.25, {opacity: 0.75})
    button4Blink = new TimelineMax({
      yoyo: true,
      repeat: -1,
      repeatDelay: 0.25
    })
    button4Blink.to('#ControlButton4', 0.25, {opacity: 0.75})
  },
  doResetAnime: function () {
    if (curAudio) {
      curAudio.stop().seek(0)
      curAudio = null
      // animeSequence.seek('done').kill().clear()
      animeSequence.seek('done').kill()
      animeSequence = null
    }
  },
  doPauseAnime: function () {
    if (curAudio) {
      curAudio.pause()
    }
  },
  doResumeAnime: function () {
    if (curAudio) {
      curAudio.play()
    }
  },
  doSequence: function (s) {
    window._.each(audio, function (a) {
      a.stop().seek(0)
    })
    if (curAudio) {
      curAudio.stop().seek(0)
      curAudio = null
    }
    if (animeSequence) {
      // animeSequence.seek('done').kill().clear()
      animeSequence.seek('done').kill()
      animeSequence = null
    }

    animeSequence = new TimelineMax({
      onStart: function () {
        // console.log('Howl = ', audio[s - 1])
        curAudio = audio[s - 1]
        curAudio.play()
      }
    })
    animeSequence.addLabel('start').to('#StartExplanation', 1, {opacity: 0})
    switch (s) {
      case 1: {
        // button1Blink.kill().clear()
        button1Blink.kill()
        button1Blink = null
        button1Blink = new TimelineMax()
        button1Blink.to('#ControlButton1', 0.5, {opacity: 1})
        animeSequence.to('#_01Explanation, #Pause-ResumeButton, #StopButton', 1, {opacity: 1, scale: 1}, 'start')
        .to('#TopLine, #BottomLine, #_02Sequence, #_03Sequence, #_04Sequence', 1, {opacity: 0.10}, '-=1')
        .addPause()
        .addLabel('end')
        .to('#TopLine, #BottomLine, #_02Sequence, #_03Sequence, #_04Sequence', 1, {opacity: 1})
        .to('#_01Explanation, #Pause-ResumeButton, #StopButton', 1, {opacity: 0, scale: 0.001}, '-=1')
        break
      }
      case 2: {
        // button2Blink.kill().clear()
        button2Blink.kill()
        button2Blink = null
        button2Blink = new TimelineMax()
        button2Blink.to('#ControlButton2', 0.5, {opacity: 1})
        animeSequence.to('#_02Explanation, #Pause-ResumeButton, #StopButton', 1, {opacity: 1, scale: 1}, 'start')
        .to('#StartLine, #TopLine, #BottomLine, #_01Sequence, #_03Sequence, #_04Sequence', 1, {opacity: 0.10}, '-=1')
        .addPause()
        .addLabel('end')
        .to('#StartLine, #TopLine, #BottomLine, #_01Sequence, #_03Sequence, #_04Sequence', 1, {opacity: 1})
        .to('#_02Explanation, #Pause-ResumeButton, #StopButton', 1, {opacity: 0, scale: 0.001}, '-=1')
        break
      }
      case 3: {
        // button3Blink.kill().clear()
        button3Blink.kill()
        button3Blink = null
        button3Blink = new TimelineMax()
        button3Blink.to('#ControlButton3', 0.5, {opacity: 1})
        animeSequence.to('#Pause-ResumeButton, #StopButton', 1, {opacity: 1, scale: 1}, 'start')
        .to('#StartLine, #BottomLine, #_01Sequence, #_02Sequence, #_04Sequence', 1, {opacity: 0.10}, '-=1')
        .addPause()
        .addLabel('end')
        .to('#StartLine, #BottomLine, #_01Sequence, #_02Sequence, #_04Sequence', 1, {opacity: 1})
        .to('#Pause-ResumeButton, #StopButton', 1, {opacity: 0, scale: 0.001}, '-=1')
        break
      }
      case 4: {
        // button4Blink.kill().clear()
        button4Blink.kill()
        button4Blink = null
        button4Blink = new TimelineMax()
        button4Blink.to('#ControlButton4', 0.5, {opacity: 1})
        animeSequence.to('#Pause-ResumeButton, #StopButton', 1, {opacity: 1, scale: 1}, 'start')
        .to('#StartLine, #TopLine, #_01Sequence, #_02Sequence, #_03Sequence', 1, {opacity: 0.10}, '-=1')
        .addPause()
        .addLabel('end')
        .to('#StartLine, #TopLine, #_01Sequence, #_02Sequence, #_03Sequence', 1, {opacity: 1})
        .to('#Pause-ResumeButton, #StopButton', 1, {opacity: 0, scale: 0.001}, '-=1')
        break
      }
      default: {}
    }
    animeSequence.to('#StartExplanation', 1, {opacity: 1})
    animeSequence.addLabel('done')
  },
  closeZoom: function () {
    if (animeZoom) {
      animeZoom.seek('close').play()
    }
    this.doResumeAnime()
  },
  doZoom: function (z, numSections, callback, isZooming) {
    this.doPauseAnime()
    if (animeZoom) {
      // animeZoom.seek('done').kill().clear()
      animeZoom.seek('done').kill()
      animeZoom = null
    }
    animeZoom = new TimelineMax({
      onComplete: function () {
        // animeZoom.kill().clear()
        animeZoom.kill()
        animeZoom = null
        // Tell the parent to close the zoom windows
        this.vars.onCompleteParams[0]()
      },
      onCompleteParams: [callback]
    })
    animeZoom.addLabel('start')
      .fromTo('#ZoomRect, #ZoomCloseButton', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1})
    switch (numSections) {
      case 4: {
        animeZoom.fromTo('#_3rdExtraZoomRect, #_3rdMoreArrow, #ZoomCloseButton4', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, 'start')
      }
      case 3: {
        animeZoom.fromTo('#_2ndExtraZoomRect, #_2ndMoreArrow, #ZoomCloseButton3', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, 'start')
      }
      case 2: {
        animeZoom.fromTo('#ExtraZoomRect, #MoreArrow, #ZoomCloseButton2', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, 'start')
      }
      default: {
      }
    }
    switch (z) {
      case 'BoneFractures': {
        animeZoom.fromTo('#BrokenBonesZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#BrokenBonesZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'InternalFixation': {
        animeZoom.fromTo('#InternalFixationZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#InternalFixationZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'DeadBone': {
        animeZoom.fromTo('#DeadBone', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#DeadBone', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'HighlyRestricted': {
        animeZoom.fromTo('#HighlyRestrictedZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#HighlyRestrictedZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'CompressionLost': {
        animeZoom.fromTo('#CompressionLostZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#CompressionLostZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'SecondaryHealing': {
        animeZoom.fromTo('#SecondaryHealingZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#SecondaryHealingZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'SecondaryHaversianRemodeling': {
        animeZoom.fromTo('#SecondaryHaversianRemodelingZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#SecondaryHaversianRemodelingZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'BMGHardware': {
        animeZoom.fromTo('#BMGHardwareZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#BMGHardwareZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'IntimateAlignment': {
        animeZoom.fromTo('#IntimateAlignmentZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#IntimateAlignmentZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'DirectHaversian': {
        animeZoom.fromTo('#DirectHaversianZoom', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#DirectHaversianZoom', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'PrimaryFinalBone': {
        animeZoom.fromTo('#PrimaryFinalBone', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#PrimaryFinalBone', 1, {opacity: 0, scale: 0.25})
        break
      }
      case 'SecondaryFinalBone': {
        animeZoom.fromTo('#SecondaryFinalBone', 1, {opacity: 0, scale: 0.25}, {opacity: 1, scale: 1}, '-=1')
          .addPause().addLabel('close')
          .to('#SecondaryFinalBone', 1, {opacity: 0, scale: 0.25})
        break
      }
    } // End switch
    switch (numSections) {
      case 4: {
        animeZoom.to('#_3rdExtraZoomRect, #_3rdMoreArrow, #ZoomCloseButton4', 1, {opacity: 0, scale: 0.25}, 'close')
      }
      case 3: {
        animeZoom.to('#_2ndExtraZoomRect, #_2ndMoreArrow, #ZoomCloseButton3', 1, {opacity: 0, scale: 0.25}, 'close')
      }
      case 2: {
        animeZoom.to('#ExtraZoomRect, #MoreArrow, #ZoomCloseButton2', 1, {opacity: 0, scale: 0.25}, 'close')
      }
      default: {
      }
    }
    // animeZoom.to('#ZoomRect, #ZoomCloseButton', 0, {opacity: 0, scale: 0.25}, 'close')
    animeZoom.to(zooms, 0.1, {opacity: 0, scale: 0.25}, 'close')
      .addLabel('done')
    isZooming = false
  }
}
